import { AvatarFlyout } from '@zeiss/beyond-online-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

export const AccountMenu = () => {
  const { t } = useTranslation(['common']);

  const { signoutRedirect, user } = useAuth();

  if (!user) return null;

  const {
    profile: { family_name, given_name },
  } = user;

  const signOut = async () => {
    await signoutRedirect();
  };

  return (
    <AvatarFlyout
      data-testid="AvatarFlyout"
      fitContent
      fullName={`${given_name} ${family_name}`}
      groups={[
        [
          {
            icon: 'Logout',
            onClick: signOut,
            title: t('common:action.signOut'),
          },
        ],
      ]}
      pointer={false}
      position="bottom-right"
      size="m"
    />
  );
};
